import { render, staticRenderFns } from "./AllAppsDetail.vue?vue&type=template&id=1fe4c900&scoped=true&"
import script from "./AllAppsDetail.vue?vue&type=script&lang=js&"
export * from "./AllAppsDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe4c900",
  null
  
)

component.options.__file = "AllAppsDetail.vue"
export default component.exports